import * as types from './actionTypes';

export function configSet(config: any) {
    return { type: types.CONFIG_SET, config };
}
